import React from 'react';
import { ChevronRight, Restaurant, User } from '@menuzen/icon/build/outline';
import { useEditor } from '@mnz/builder';
import Dialog, { DialogProps } from '../../../../components/dialog/Dialog';

const PROFILE_ELEMENTS = [
    {
        name: 'BasicInfo',
        title: 'Basic Information',
        icon: <Restaurant />,
    },
    {
        name: 'Social',
        title: 'Social Links',
        icon: <User />,
    },
];

const ProfileModal: React.FC<DialogProps> = ({ ...props }) => {
    const {
        actions: { selectNode },
        nodeIds,
    } = useEditor((_, query) => {
        const nodes = query.getNodes();
        const nodeIds: Record<string, string> = {};
        if (nodes.ROOT) {
            nodes.ROOT.data.nodes.forEach((node: string) => {
                nodeIds[nodes[node].data.name] = nodes[node].id;
            });
        }
        return {
            nodeIds,
        };
    });

    return (
        <Dialog {...props}>
            <div className="mt-20 px-30 pb-40">
                {PROFILE_ELEMENTS.map((element) => (
                    <div
                        className="flex items-center justify-between py-12 border-b border-primary-40 cursor-pointer"
                        onClick={() => selectNode(nodeIds[element.name])}
                        key={element.name}
                    >
                        <div className="text-20 h-35 w-35 rounded-5 flex items-center justify-center bg-started mr-8">
                            {element.icon}
                        </div>
                        <div className="flex-grow text-left text-18 leading-none">{element.title}</div>
                        <div className="text-20 text-primary-50">
                            <ChevronRight />
                        </div>
                    </div>
                ))}
            </div>
        </Dialog>
    );
};

export default ProfileModal;
